import { useEffect, useState } from "react";
import { dateMinus, datePlus } from "../../Reusables/fullDate";
import { Link } from "react-router-dom";

export default function DateBrowser({ date, sport, timezone}){

    const [today, setToday] = useState(date);
    const [tomorrow, setTomorrow] = useState('');
    const [yesterday, setYesterday] = useState('');



    useEffect(()=>{
      setToday(date);

      const todayDate = new Date(date);
      const yesterdayDate = dateMinus(todayDate);
      setYesterday(yesterdayDate);

      const tomorrowDate = datePlus(todayDate);
      setTomorrow(tomorrowDate);
    },[date]);

    return(
        <>
        <div className="date-bar">
              <Link to={`/${sport}/${yesterday}?tz=${encodeURIComponent(timezone)}`}><button className="left-arrow-btn"></button></Link><h2>{today}</h2><Link to={`/${sport}/${tomorrow}?tz=${encodeURIComponent(timezone)}`}><button className="right-arrow-btn"></button></Link>
              </div>
        </>
    )
}